import React from 'react';
import { Link } from 'react-router-dom';

interface NavigationLinkProps {
  label: string;
  dest: string;
  tabIndex?: number;
  color?: string;
}

const NavigationLink: React.FC<NavigationLinkProps> = ({
  label,
  dest,
  color = 'green',
  tabIndex,
}) => {
  return (
    <>
      <Link
        tabIndex={tabIndex}
        to={dest}
        className={`underline font-medium tracking-tight text-${color}`}
      >
        {label}
      </Link>
    </>
  );
};

export default NavigationLink;
